/*
 * Footer newsletter signup → Klaviyo client Subscriptions API.
 *
 * Native, first-party form (NOT a Klaviyo embed), so it renders and
 * submits regardless of cookie consent — submitting an email is itself
 * the opt-in, and no third-party tracking script is required to show it.
 *
 * The public company_id (Site ID) is taken from the form's data attribute
 * if set, else auto-detected from the Klaviyo onsite script the app embed
 * loads (?company_id=XXXXXX), else from the global klaviyo SDK. Only the
 * PUBLIC key is ever used client-side — never a private key.
 *
 * Subscribers land on the list in data-yt-klaviyo-list; double opt-in is
 * governed by that list's settings in Klaviyo.
 */
(function () {
  var form = document.querySelector('.yt-footer__signup-form');
  if (!form) return;

  var input = form.querySelector('input[type="email"]');
  var btn = form.querySelector('button[type="submit"]');
  var msg = document.querySelector('.yt-footer__signup-msg');
  var listId = form.getAttribute('data-yt-klaviyo-list');

  function publicKey() {
    var k = (form.getAttribute('data-yt-klaviyo-key') || '').trim();
    if (k && k !== 'XXXXXX') return k;
    var scripts = document.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var src =
        scripts[i].src ||
        scripts[i].getAttribute('data-cookieblock-src') ||
        scripts[i].getAttribute('data-src') ||
        '';
      // Klaviyo loads as ?company_id=XXXXXX and/or /onsite/js/XXXXXX/klaviyo.js
      var m =
        src.match(/[?&]company_id=([A-Za-z0-9]+)/) ||
        src.match(/static\.klaviyo\.com\/onsite\/js\/([A-Za-z0-9]+)\//);
      if (m && m[1] !== 'XXXXXX') return m[1];
    }
    try {
      if (window.klaviyo && typeof window.klaviyo.account === 'function') {
        var a = window.klaviyo.account();
        if (a) return a;
      }
    } catch (e) {}
    return null;
  }

  function say(text, ok) {
    if (!msg) return;
    msg.hidden = false;
    msg.textContent = text;
    msg.classList.toggle('is-ok', !!ok);
    msg.classList.toggle('is-error', !ok);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (input.value || '').trim();
    if (!email || email.indexOf('@') < 1) {
      say('Please enter a valid email.', false);
      return;
    }
    var company = publicKey();
    if (!company || !listId) {
      say('Sign-up is unavailable right now.', false);
      return;
    }
    if (btn) btn.disabled = true;
    say('Subscribing…', true);

    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Footer signup',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    })
      .then(function (r) {
        if (btn) btn.disabled = false;
        if (r.status === 202 || (r.status >= 200 && r.status < 300)) {
          form.reset();
          say('Thanks — you’re on the list!', true);
        } else {
          say('Sorry, something went wrong. Please try again.', false);
        }
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        say('Sorry, something went wrong. Please try again.', false);
      });
  });
})();
